<template>
  <div class="dispute-submit-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>提交争议/复测申请</h2>
        <div class="header-actions">
          <el-button @click="$router.back()">返回</el-button>
        </div>
      </div>
      
      <el-form ref="disputeForm" :model="disputeForm" :rules="rules" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="orderInfo.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号">
              <el-input v-model="orderInfo.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="orderInfo.customer" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="orderInfo.contact" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24" v-if="!isCustomerView && orderInfo.referencePrice">
          <el-col :span="12">
            <el-form-item label="参考价格">
              <el-input v-model="orderInfo.referencePrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="orderInfo.actualPrice">
            <el-form-item label="实际价格">
              <el-input v-model="orderInfo.actualPrice" disabled>
                <template slot="prepend">¥</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商家名称">
              <el-input v-model="orderInfo.merchant" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息">
              <el-input v-model="orderInfo.equipment" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">测试要求附件</span>
        </el-divider>
        
        <div class="file-list-container" v-if="orderFiles.length > 0">
          <el-table
            :data="orderFiles"
            style="width: 100%; margin-bottom: 15px;"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>
        
        <el-divider content-position="left">
          <span class="divider-title">测试结果附件</span>
        </el-divider>
        
        <div class="file-list-container" v-if="testResultFiles.length > 0">
          <el-table
            :data="testResultFiles"
            style="width: 100%; margin-bottom: 15px;"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>
        
        <el-divider content-position="left">
          <span class="divider-title">提出争议/复测申请</span>
        </el-divider>
        
        <el-card class="dispute-form-card">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="申请类型" prop="disputeType">
                <el-radio-group v-model="disputeForm.disputeType">
                  <el-radio label="dispute">争议</el-radio>
                  <el-radio label="retest">复测</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="申请原因" prop="disputeReason">
                <el-input 
                  type="textarea" 
                  v-model="disputeForm.disputeReason" 
                  :rows="4"
                  placeholder="请详细说明提出争议/复测的原因">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="上传附件">
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="customUpload"
                  multiple
                  drag
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-error="handleError"
                  :before-upload="beforeUpload"
                  :file-list="disputeForm.fileList">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">
                    支持上传PDF、Word、Excel或图片格式文件，每个文件不超过10MB。
                    请上传能够证明争议/复测理由的相关文件。
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        
        <div class="uploaded-files" v-if="disputeForm.fileList.length > 0">
          <h3 class="file-list-title">已上传文件</h3>
          <el-table
            :data="disputeForm.fileList"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)"
                  style="margin-left: 10px;">下载</el-button>
                <el-button 
                  type="text" 
                  size="small"
                  style="color: #F56C6C; margin-left: 10px;"
                  @click="handleRemoveUploaded(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <el-row :gutter="24" style="margin-top: 30px;">
          <el-col :span="24">
            <div class="form-actions">
              <el-button type="primary" @click="submitForm" :loading="loading">提交申请</el-button>
              <el-button @click="cancel">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'DisputeSubmit',
  data() {
    return {
      orderId: null,
      orderInfo: {
        projectName: '',
        orderNo: '',
        customer: '',
        contact: '',
        merchant: '',
        equipment: ''
      },
      orderFiles: [], // 测试要求附件
      testResultFiles: [], // 测试结果附件
      disputeForm: {
        disputeType: 'dispute', // dispute: 争议, retest: 复测
        disputeReason: '',
        fileList: []
      },
      rules: {
        disputeType: [
          { required: true, message: '请选择申请类型', trigger: 'change' }
        ],
        disputeReason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' },
          { min: 10, message: '申请原因不能少于10个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      isCustomerView: false
    }
  },
  created() {
    // 检查当前路径，判断是否是客户端访问
    this.isCustomerView = this.$route.path.includes('/customer/');
    // 从路由参数获取订单ID
    this.orderId = this.$route.params.id
    // 从查询参数获取申请类型
    const disputeType = this.$route.query.type
    if (disputeType && (disputeType === 'dispute' || disputeType === 'retest')) {
      this.disputeForm.disputeType = disputeType
    }
    
    if (this.orderId) {
      this.fetchOrderDetail()
    } else {
      this.$message.error('订单ID不能为空')
      this.$router.push('/admin/orders/all')
    }
  },
  methods: {
    // 获取订单详情
    fetchOrderDetail() {
      this.loading = true
      // 这里应该调用API获取订单详情
      // 模拟数据
      setTimeout(() => {
        this.orderInfo = {
          projectName: '测试项目',
          orderNo: 'ORDER-2023-001',
          customer: '测试客户',
          contact: '张三',
          merchant: '测试商家',
          equipment: '测试仪器A'
        }
        this.orderFiles = [
          { name: '测试要求说明.pdf', size: 1024000 },
          { name: '产品规格书.docx', size: 512000 }
        ]
        this.testResultFiles = [
          { name: '测试报告.pdf', size: 2048000 },
          { name: '测试数据.xlsx', size: 256000 }
        ]
        this.loading = false
      }, 1000)
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return `${size.toFixed(2)} ${units[index]}`
    },
    // 预览文件
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    // 下载文件
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    // 删除文件
    handleRemove(file, fileList) {
      console.log('删除文件', file, fileList)
      this.disputeForm.fileList = fileList
    },
    // 删除已上传文件
    handleRemoveUploaded(index) {
      this.disputeForm.fileList.splice(index, 1)
    },
    // 上传文件错误处理
    handleError(err) {
      console.error('上传文件错误', err)
      this.$message.error('文件上传失败，请重试')
    },
    // 上传前验证
    beforeUpload(file) {
      const isValidType = this.validateFileType(file)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传PDF、Word、Excel或图片格式文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }
      return true
    },
    // 验证文件类型
    validateFileType(file) {
      const validTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ]
      return validTypes.includes(file.type)
    },
    // 自定义上传方法
    customUpload({ file }) {
      // 这里应该调用API上传文件
      // 模拟上传成功
      setTimeout(() => {
        this.disputeForm.fileList.push({
          name: file.name,
          size: file.size,
          url: URL.createObjectURL(file)
        })
      }, 500)
    },
    // 提交表单
    submitForm() {
      this.$refs.disputeForm.validate(valid => {
        if (valid) {
          // 表单验证通过，提交数据
          this.loading = true
          // 这里应该调用API提交数据
          console.log('提交数据', {
            orderId: this.orderId,
            disputeType: this.disputeForm.disputeType,
            disputeReason: this.disputeForm.disputeReason,
            files: this.disputeForm.fileList
          })
          
          // 模拟提交成功
          setTimeout(() => {
            this.loading = false
            this.$message.success('提交成功')
            this.$router.push(`/admin/orders/detail/${this.orderId}`)
          }, 1500)
        } else {
          this.$message.error('请正确填写表单')
          return false
        }
      })
    },
    // 取消
    cancel() {
      this.$router.push(`/admin/orders/detail/${this.orderId}`)
    }
  }
}
</script>

<style scoped>
.dispute-submit-container {
  padding: 20px;
}

.order-card {
  margin-bottom: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.divider-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.file-list-container {
  margin-bottom: 20px;
}

.no-file {
  margin: 20px 0;
}

.form-actions {
  margin-top: 30px;
  text-align: center;
}

.upload-demo {
  width: 100%;
}

.file-list-title {
  font-size: 16px;
  margin: 20px 0 15px 0;
  color: #409EFF;
}

.uploaded-files {
  margin-top: 20px;
}

.dispute-form-card {
  background-color: #f9f9f9;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}
</style> 